const navbar = document.querySelector('nav.top');
const dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
const dropdownList = dropdownElementList.map(dropdownToggleEl => {
    const dropdownInstance = new bootstrap.Dropdown(dropdownToggleEl);
    dropdownToggleEl.addEventListener('click', () => closeDropdowns(dropdownInstance));
    return dropdownInstance;
});

function closeDropdowns(clickedDropdownInstance) {
    dropdownList.forEach(dropdown => {
        //Close all menus except the one clicked AND all its parents
        if(clickedDropdownInstance) {
            if(dropdown !== clickedDropdownInstance && !dropdown._menu.contains(clickedDropdownInstance._element)) {
                dropdown.hide();
            }
        } else {
            dropdown.hide();
        }
    });
}

if(navbar) {
    document.addEventListener('click', e => {
        if((!e.target.closest('.dropdown-toggle') && !navbar.contains(e.target))) {
            closeDropdowns();
        }
    });
    
    document.querySelectorAll('.nav-item:not(.dropdown)').forEach(navItem => navItem.addEventListener('click', () => closeDropdowns()));
}
